import { ExpandLess } from '@mui/icons-material';
import {
  Box,
  Button,
  ButtonGroup,
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Stack,
} from '@mui/material';
import React from 'react';
import { FormattedMessage } from 'react-intl';

interface ControlBarButtonProps {
  icon: React.ReactNode;
  label?: string;
  onLeaveClick?: () => void;
  onEndClick?: () => void;
}

function ControlBarSplitButton({
  icon,
  label = '',
  onLeaveClick = () => {},
  onEndClick = () => {},
}: ControlBarButtonProps) {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };

  return (
    <Stack justifyContent='flex-start' alignItems='center'>
      <Box marginBottom='4px'>
        <ButtonGroup
          sx={{
            '.MuiButtonGroup-firstButton': {
              borderColor: 'white',
            },
          }}
          variant='contained'
          ref={anchorRef}
        >
          <Button
            sx={{
              padding: '8px 16px',
              borderRadius: '76px 0px 0px 76px',
              background: (theme) => theme.palette.red[500],
              border: 'unset',
              borderColor: 'white',

              '&:hover': {
                background: (theme) => theme.palette.red[400],
              },
            }}
            onClick={onLeaveClick}
          >
            {icon}
          </Button>
          <Button
            sx={{
              padding: 'unset',
              paddingRight: '4px',
              alignItems: 'center',
              borderRadius: '48px',
              background: (theme) => theme.palette.red[500],

              '&:hover': {
                background: (theme) => theme.palette.red[400],
              },
            }}
            onClick={handleToggle}
          >
            <ExpandLess />
          </Button>
        </ButtonGroup>
        <Popper
          sx={{
            zIndex: 1,
          }}
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
          placement='top-start'
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === 'bottom' ? 'center top' : 'center bottom',
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList id='split-button-menu' autoFocusItem>
                    <MenuItem onClick={onLeaveClick}>
                      <FormattedMessage defaultMessage='Leave' />
                    </MenuItem>
                    <MenuItem onClick={onEndClick}>
                      <FormattedMessage defaultMessage='End meeting' />
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </Box>
      {label && (
        <Box
          sx={{
            color: (theme) => theme.palette.neutralBlackBg[50],
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: '500',
            lineHeight: '125%',
            width: '100%',
            paddingLeft: '11px',
          }}
        >
          {label}
        </Box>
      )}
    </Stack>
  );
}

export default ControlBarSplitButton;
